import PostRowItem from "./PostRowItem";

export default PostRowItem;
